import React, { FC } from "react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { cn } from "@/lib/utils";
import { cva, type VariantProps } from "class-variance-authority";

const buttonVariants = cva(
  "w-full min-w-[200px] mb-3 bg-green-200 text-green-800",
  {
    variants: {
      variant: {
        default: "bg-white text-[#818182]",
        primary: "bg-[#cce5ff] text-[#424095]",
        secondary: "bg-[#e2e3e5] text-[#383d41]",
        success: "bg-[#d4edda] text-[#155724]",
        danger: "bg-[#f8d7da] text-[#721c24]",
        warning: "bg-[#fff3cd] text-[#856404]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

interface CAlertProps {
  title: string;
  body: React.ReactNode;
  icon: React.ReactNode;
  variant?: VariantProps<typeof buttonVariants>["variant"];
}

const CAlert: FC<CAlertProps> = ({ title, icon, body, variant }) => {
  return (
    <Alert className={cn(buttonVariants({ variant }))}>
      {icon}
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription>{body}</AlertDescription>
    </Alert>
  );
};

export default CAlert;
